import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CountBg from "@/assets/img/eam/count_bg.png";
import AssetNumber from "@/assets/img/eam/asset_number.png";
import AssetTotalValue from "@/assets/img/eam/asset_total_value.png";
import AssetBookValue from "@/assets/img/eam/asset_book_value.png";
import AssetDepre from "@/assets/img/eam/asset_depre.png";
import AssetNetValue from "@/assets/img/eam/asset_net_value.png";
import { eamApi } from "@/api/eamApi";
const CountHeader = ({ className = "" }) => {
    const [dataSource, setDataSource] = useState();
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await eamApi.total();
            setDataSource(res.data);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    return (_jsx("div", { className: `
      flex flex-row
      items-center
      justify-between
      w-full
      overflow-hidden
      bg-transparent
      text-white
      ${className}
    `, children: [
            {
                icon: AssetNumber,
                label: "资产数量",
                value: dataSource?.total,
                unit: "项",
            },
            {
                icon: AssetTotalValue,
                label: "总原值",
                value: (dataSource?.originalValue
                    ? dataSource?.originalValue / 10000
                    : 0).toFixed(2),
                unit: "万元",
            },
            {
                icon: AssetBookValue,
                label: "账面价值",
                value: (dataSource?.bookValue
                    ? dataSource?.bookValue / 10000
                    : 0).toFixed(2),
                unit: "万元",
            },
            {
                icon: AssetDepre,
                label: "累计折旧",
                value: (dataSource?.endValue
                    ? dataSource?.endValue / 10000
                    : 0).toFixed(2),
                unit: "万元",
            },
            {
                icon: AssetNetValue,
                label: "净值",
                value: (dataSource?.netValue
                    ? dataSource?.netValue / 10000
                    : 0).toFixed(2),
                unit: "万元",
            },
        ].map((item, idx) => (_jsxs("div", { className: "flex-1 flex flex-row items-center h-[0.37rem] pr-[0.08rem] min-w-0" // 37px→0.37rem，8px→0.08rem
            , style: {
                backgroundImage: `url(${CountBg})`,
                backgroundSize: "cover",
                backgroundPosition: "left center",
                backgroundRepeat: "no-repeat",
            }, children: [_jsx("img", { src: item.icon, alt: item.label, style: {
                        width: "0.49rem",
                        height: "0.37rem",
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                    }, className: "flex-shrink-0" //
                 }), _jsx("span", { className: "text-sm opacity-90 flex-shrink-0 mx-[0.06rem]", style: {
                        fontSize: "0.21rem",
                        fontFamily: "Source Han Sans CN",
                        fontWeight: "bolder",
                        whiteSpace: "nowrap",
                    }, children: item.label }), _jsxs("div", { className: "ml-auto flex items-end gap-[0.04rem] flex-shrink-1 pl-[0.1rem]", children: [_jsx("span", { className: "text-xl font-bold", style: {
                                fontSize: "0.3rem",
                                background: "linear-gradient(to bottom, #A465FF, #FFFFFF)",
                                WebkitBackgroundClip: "text",
                                backgroundClip: "text",
                                color: "transparent",
                                lineHeight: "1",
                            }, children: item.value }), _jsx("span", { style: { fontSize: "0.16rem", lineHeight: "none" }, children: item.unit })] })] }, idx))) }));
};
export default CountHeader;
